import React from "react"
import tw, { css, styled, theme } from "twin.macro"
import { ReactComponent as MenuSVG } from "../../assets/icons/menu.svg"

const MobileMenuIcon = styled(MenuSVG)(() => [
  tw`tablet-lg:(hidden) hover:cursor-pointer`,
  css`
    line {
      stroke: ${theme(`colors.base-6`)};
    }
  `,
])

const Skeleton = () => {
  return (
    <>
      <ul
        data-testid="nav-skeleton"
        tw="hidden w-full tablet-lg:(flex justify-between w-auto space-x-8 pl-4) desktop:(space-x-8) desktop-lg:(space-x-16)"
      >
        <li tw="flex items-center space-x-3">
          <div tw="bg-base-2 rounded-full w-11 h-11"></div> <div tw="bg-base-2 rounded-full w-8 h-8"></div>
        </li>
      </ul>
      <MobileMenuIcon />
    </>
  )
}

export default Skeleton
